import React from "react";
import { Card, Image } from "react-bootstrap";
import "./BenefitsMassage.css"; // Import custom CSS
// Import your images
import image1 from "./Flaticon.jpg";
import image2 from "./Cupping.jpg";
import image3 from "./FootMassage.jpg";
import image4 from "./HeadMassage.jpg";
import image5 from "./posture.jpg";
import image6 from "./waist.jpg";
import image7 from "./muscles.jpg";
import image8 from "./lotus.jpg";
import SEO from "../../SEO";
import BookingComponent from "../Our Treatments 2/BookNow/BookNowCall";

const BenefitsMassage = () => {
  const cardsData = [
    {
      id: 1,
      title: "Relieve Pain",
      image: image1,
      info: "Experience the soothing relief from chronic discomfort with our professional massage therapies tailored to your needs.",
    },
    {
      id: 2,
      title: "Reduce Spasms",
      image: image2,
      info: "Reduce muscle spasms and tension with targeted massage techniques to promote relaxation and flexibility.",
    },
    {
      id: 3,
      title: "Prevent Injuries",
      image: image3,
      info: "Experience therapy sessions from experts designed to accelerate your injury recovery process effectively and safely.",
    },
    {
      id: 4,
      title: "Movement Range",
      image: image4,
      info: "Enhance your flexibility with therapeutic massage, enabling easy movement.",
    },
    {
      id: 5,
      title: "Improved Posture",
      image: image5,
      info: "Improve your posture and well-being with our personalized massage sessions focused on alignment and balance.",
    },
    {
      id: 6,
      title: "Reduce Waist",
      image: image6,
      info: "Reduce inches and sculpt your waistline with treatments to promote detoxification and slimming.",
    },
    {
      id: 7,
      title: "Muscles Healthy",
      image: image7,
      info: "Maintain optimal muscle health and function with consistent spa and massage sessions that promote circulation and relieve tension.",
    },
    {
      id: 8,
      title: "Promote Healing",
      image: image8,
      info: "Boost your body's natural healing mechanisms with our holistic massage and therapy approach.",
    },
  ];

  return (
    <div className="Benifitmain">
      <SEO
        title="Benefits of Massage"
        description="Benefits of Massage"
        keywords="spa, massage, therapy, wellness, benefits"
        canonical='https://shrikrishnaarogyammassagestherapy.com/benefits'
      />
      <div className="massage-header">
        <center>
          <div className="header-content">
            <h1 className="massage-h1">BENEFITS OF MASSAGE</h1>

          </div>
        </center>
      </div>
      <div className="massage-intro">
      <h4 className="massage-description">
              Massage provides a wide range of benefits, from relaxation to
              stress relief. By reducing stress, it significantly enhances
              mental clarity and emotional well-being. It effectively relieves
              muscle tension and pain, improving circulation, and increasing
              flexibility. Regular massage sessions can not only support immune
              health but also promote better sleep, leading to an energized
              lifestyle.
            </h4>
      </div>

      <div className="massage-background massageBg">
        <div className="massage-card-grid">
          {cardsData.map((card) => (
            <div className="massage-flip-card" key={card.id}>
              <div className="massage-flip-card-inner">
                {/* Front of the card */}
                <div className="massage-flip-card-front">
                  <Card className="massage-card">
                    <div className="massage-circular-image-container">
                      <Image src={card.image} />
                    </div>
                    <Card.Body className="massage-body">
                      <Card.Title className="card-title">
                        {card.title}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </div>

                {/* Back of the card */}
                <div className="massage-flip-card-back">
                  <Card.Body className="massage-body">
                    <Card.Text className="card-text">{card.info}</Card.Text>
                  </Card.Body>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <BookingComponent/>
    </div>
  );
};

export default BenefitsMassage;
